var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrRefer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.9771,
    cy: 64,
    r: 64,
    fill: "#E9F1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4246 26.3032V42.7725H31.7739V30.5995H44.0971V26.3032H27.4246Z",
    fill: "#123051"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9809 26.3032V30.5995H97.3041V42.7725H101.653V26.3032H84.9809Z",
    fill: "#123051"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3042 83.1626V95.3357H84.981V99.6318H101.654V83.1626H97.3042Z",
    fill: "#123051"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4241 83.1626V99.6318H44.0967V95.3357H31.7735V83.1626H27.4241Z",
    fill: "#123051"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1715 47.7842H44.8221V43.4879H49.1715V47.7842Z",
    fill: "#123051"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2561 47.7842H79.9068V43.4879H84.2561V47.7842Z",
    fill: "#123051"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1715 82.4443H44.8221V78.148H49.1715V82.4443Z",
    fill: "#123051"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0478 64.9707H78.6984V60.6744H83.0478V64.9707Z",
    fill: "#123051"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5204 65.2588H49.1711V60.9625H53.5204V65.2588Z",
    fill: "#123051"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2561 82.4443H79.9068V78.148H84.2561V82.4443Z",
    fill: "#123051"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5205 86.7398H40.4724V73.8508H53.5205V86.7398ZM40.4724 69.5545V65.2582H44.8218V60.9619H36.123V91.0361H57.8699V69.5545H40.4724Z",
    fill: "#123051"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5575 39.1928H88.6056V52.0817H75.5575V39.1928ZM71.2081 34.8964V56.3781H88.6056V64.9707H92.9549V34.8964H71.2081Z",
    fill: "#123051"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3641 45.6391V64.9727H64.5388L65.9886 55.8549L64.5388 45.6391H62.3641Z",
    fill: "#123051"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3494 60.6763H66.7138V45.6391H64.5391V64.9727H74.3494V60.6763Z",
    fill: "#123051"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.364 78.15V82.4463H64.5386L65.9884 80.2981L64.5386 78.15H62.364Z",
    fill: "#123051"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7138 78.148H64.5391V82.4443H66.7138V78.148Z",
    fill: "#123051"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.364 69.5523V73.8486H64.5387L65.9885 71.784L64.5387 69.5523H62.364Z",
    fill: "#123051"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7138 69.5552H64.5391V73.8516H66.7138V69.5552Z",
    fill: "#123051"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5205 52.0836H40.4724V39.1946H53.5205V52.0836ZM36.123 34.8983V56.3799H57.8699V39.1946H64.5389L65.9887 37.0464L64.5389 34.8983H36.123Z",
    fill: "#123051"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8588 34.899H64.5391V39.1953H66.8588V34.899Z",
    fill: "#123051"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3641 86.7418V91.0381H64.5388L65.9886 88.699L64.5388 86.7418H62.3641Z",
    fill: "#123051"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6056 86.7398H75.5575V73.8508H88.6056V86.7398ZM92.955 69.5545H71.2081V86.7398H64.5391V91.0361H92.955V69.5545Z",
    fill: "#123051"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrRefer);
export default __webpack_public_path__ + "static/media/QrRefer.3c6b978e4c5b81c827d6e06f7c5edfce.svg";
export { ForwardRef as ReactComponent };